import {
  ADD_CAMPAIGN,
  ADD_CAMPAIGN_FAILURE,
  ADD_CAMPAIGN_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const addCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CAMPAIGN:
      return { ...state, loading: true };
    case ADD_CAMPAIGN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ADD_CAMPAIGN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default addCampaignReducer;
